export default __webpack_public_path__ + "58141e8461b9e710cb23adfc825fb634.woff";